/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Ad_Plugin_No_LicensesInputs */

const en_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.count} AD Plugin licenses are currently in use. Please contact support@closedcaptioncreator.com to purchase additional licenses.`)
};

const fr_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toutes les ${i?.count} licences du plug-in AD sont actuellement utilisées. Veuillez contacter support@closedcaptioncreator.com pour acheter des licences supplémentaires.`)
};

const de_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Lizenzen für das ${i?.count} AD-Plugin sind derzeit belegt. Bitte kontaktieren Sie support@closedcaptioncreator.com, um zusätzliche Lizenzen zu erwerben.`)
};

const it_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutte le licenze del plugin ${i?.count} AD sono attualmente in uso. Contattare support@closedcaptioncreator.com per acquistare licenze aggiuntive.`)
};

const ru_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Все лицензии плагина ${i?.count} AD в настоящее время используются. Для приобретения дополнительных лицензий, пожалуйста, свяжитесь со службой поддержки по адресу support@closedcaptioncreator.com.`)
};

const es_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas las licencias del complemento AD ${i?.count} están actualmente en uso. Para adquirir licencias adicionales, contacte con support@closedcaptioncreator.com.`)
};

const zh_cn2_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`所有${i?.count}广告插件许可证目前均已使用。如需购买更多许可证，请联系support@closedcaptioncreator.com。`)
};

const ja_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在、${i?.count} ADプラグインのライセンスはすべて使用中です。追加ライセンスのご購入はsupport@closedcaptioncreator.comまでお問い合わせください。`)
};

const hi_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सभी ${i?.count} AD प्लगइन लाइसेंस वर्तमान में उपयोग में हैं। अतिरिक्त लाइसेंस खरीदने के लिए कृपया support@closedcaptioncreator.com पर संपर्क करें।`)
};

const pt_pt2_team_manager_ad_plugin_no_licenses = /** @type {(inputs: Team_Manager_Ad_Plugin_No_LicensesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as licenças do plugin ${i?.count} AD estão atualmente em uso. Entre em contato com support@closedcaptioncreator.com para adquirir licenças adicionais.`)
};

/**
* | output |
* | --- |
* | "All {count} AD Plugin licenses are currently in use. Please contact support@closedcaptioncreator.com to purchase additional licenses." |
*
* @param {Team_Manager_Ad_Plugin_No_LicensesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_ad_plugin_no_licenses = /** @type {((inputs: Team_Manager_Ad_Plugin_No_LicensesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Ad_Plugin_No_LicensesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "de") return de_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "it") return it_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "ru") return ru_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "es") return es_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "ja") return ja_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "hi") return hi_team_manager_ad_plugin_no_licenses(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_ad_plugin_no_licenses(inputs)
	return en_team_manager_ad_plugin_no_licenses(inputs)
});